module.exports = __webpack_public_path__ + "img/single-tag.c73ba2f0.png";